import axios from "axios";
import { APIURL } from "../config";
import useAuth from "../utils/useAuth";

const GetGenerateReportAPI = async (data) => {
  const user = useAuth();
  const url = APIURL + "/document/viewdashboardsummary";
  return await axios.post(url, { access_token: user.token, ...data });
};

export default GetGenerateReportAPI;
